import { Directive } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator, NG_VALIDATORS } from '@angular/forms';

@Directive({
  selector: '[futuredatetime]',
  providers: [{ provide: NG_VALIDATORS, useExisting: FutureDateTimeValidatorDirective, multi: true }]
})
export class FutureDateTimeValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
    if (control && control.hasOwnProperty('value') && control.value) {
        if (control.value.toString() === 'Invalid Date') {
            return {futuredatetime: {}};
        }
        const now = new Date();
        return control.value > now ? null : {futuredatetime: {}};
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/validators/futuredatetime.directive.ts